// Session.js
import React from 'react';
import Stopwatch from './StopWatch';
import {
  formatTime,
  generateSessionStreak,
  propsToText,
} from '../utils/functions';

const Session = ({
  noCurrentBook,
  isRunning,
  isActive,
  handleStop,
  handleStart,
  time,
  t,
  currentBook,
  sessions,
  weekstart,
}) => (
  <div className="topbar">
    <div className="topbar-container">
      <button
        disabled={noCurrentBook}
        className={`session-start ${noCurrentBook && 'btn-disabled'}`}
        onClick={() => (isRunning ? handleStop() : handleStart())}
      >
        <Stopwatch isRunning={isRunning} time={time} />
        {isRunning ? t.stop : t.start}
      </button>
      <div className="separator-vertical"></div>
      {isActive ? (
        <div className="session-running">
          <div className="stop-watch">{formatTime(time)}</div>
          <div className="fs-xs pt-65">
            {currentBook.title}
            {` ${t.by} `}
            {propsToText(currentBook.author_name, 1)}
          </div>
        </div>
      ) : (
        <div className="session-streak">
          {generateSessionStreak(sessions, weekstart)}
        </div>
      )}
    </div>
  </div>
);

export default Session;
